import { RequestService } from '../../../../../common/services/RequestService';
import { API_USER } from '../../constants';
import editUserAdjustData from './editUserAdjustData';

export const editUserRequest = async (userId, payload) => {
  const data = editUserAdjustData(payload);
  const response = await RequestService.put(API_USER + '/' + userId, data);

  return response.data;
};
